import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgPanelComponent, ExgSelectComponent} from 'exc-controls-v2';
import {Editor} from 'tinymce';
import {ApplicationService} from '../../services/application.service';
import {EnumerationService} from '../../services/enumeration.service';

@Component({
  selector: 'app-receipt-statement-details',
  templateUrl: './receipt-statement-details.component.html',
  styles: [
  ]
})
export class ReceiptStatementDetailsComponent
  extends ExcTranslation
  implements OnInit
{
  @Input()
  workspace: any;
  @Input()
  canEdit = false;
  @Input()
  checkview = {} as any;
  @Input()
  details = {} as any;

  @ViewChild('VCCommentTArea', { read: ElementRef })
  VCCommentTArea!: ElementRef;
  @ViewChild('VCComment', { read: ElementRef }) VCComment!: ElementRef;
  @ViewChild('VCReason') VCReason!: ExgSelectComponent;
  @ViewChild('VCExgPanelReasons') VCExgPanelReasons!: ExgPanelComponent;

  // @ts-ignore
  MCEinit: any = {
    placeholder: '',
    formats: {
      bold: [{inline: 'span', styles: {fontWeight: 'bold'}}],
      italic: [{inline: 'span', styles: {fontStyle: 'italic'}}]
    },
    base_url: './tinymce',
    suffix: '.min',
    inline: false,
    height: '100%',
    resize: false,
    menubar: false,
    statusbar: false,
    plugins: ['paste'],

    valid_styles: {
      '*': 'font-weight,font-style,text-decoration,text-align,color,background-color'
    },

    paste_preprocess: (plugin: any, args: any) => {
      // args.content ist ein HTML-String
      args.content = args.content
        .replace(/font-family\s*:\s*[^;"']+;?/gi, '')
        .replace(/font-size\s*:\s*[^;"']+;?/gi, '')
        .replace(/<font[^>]*>/gi, '')
        .replace(/<\/font>/gi, '');
    },

    content_style:
      '@import url(\'https://fonts.googleapis.com/css?family=Calibri\'); body { font-family: Calibri; font-size: 11pt; }',
    toolbar:
      'bold italic underline strikethrough| \
      alignleft aligncenter alignright alignjustify | \
      forecolor backcolor emoticons',
    contextmenu: 'bold italic underline strikethrough| \
    alignleft aligncenter alignright alignjustify | \
    forecolor backcolor emoticons | EXAKTFieldInsertPosition2 EXAKTFieldInsertSummierung',
    setup: (editor: any) => {}
  };
  MCEinitDisabled: any = {
    placeholder: '',
    formats: {
      bold: [{inline: 'span', styles: {fontWeight: 'bold'}}],
      italic: [{inline: 'span', styles: {fontStyle: 'italic'}}]
    },
    base_url: './tinymce',
    suffix: '.min',
    inline: false,
    height: '100%',
    resize: false,
    menubar: false,
    statusbar: false,
    toolbar: '',
    contextmenu: '',
    setup: (editor: Editor) => {

    }
  };
  _statementEditMode = false;

  get statementEditMode(): boolean {
    return this._statementEditMode ? this._statementEditMode : false;
  }
  set statementEditMode(value: boolean) {
    if (value && this.checkview) {
      this.checkview.checkChanges = true;
    }
    if (this.canEdit) {
      this._statementEditMode = value;
    }
  }

  get statementChanged(): boolean {
    return JSON.stringify(this.statement) !== JSON.stringify(this.statementClone);
  }

  statement = {
    rcptStatementTextLCD: 0,
    rcptStatementTextLCU: '',
    rcptStatementText: '',
    rcptStatementReason: '',
  };
  statementClone = {
    rcptStatementTextLCD: 0,
    rcptStatementTextLCU: '',
    rcptStatementText: '',
    rcptStatementReason: '',
  };

  constructor(
    private appSrv: ApplicationService,
    public enumSvc: EnumerationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
  }

  initialize(): void {
    if (this.workspace) {
      if (this.workspace.receiptData
          && this.details.taskDetails
      ) {
        const defaultComment = '<p>Sehr geehrte Damen und Herren,</p>' +
          '<br><br><p>Mit freundlichen Grüßen</p>' +
          '<p>' + (this.details.taskDetails.Bearbeiter && this.details.taskDetails.Bearbeiter.length > 0 ?
            this.details.taskDetails.Bearbeiter : '')
          + '</p>';

        this.statement = {
          rcptStatementTextLCD: this.workspace.receiptData.rcptStatementTextLCD || Date.now(),
          rcptStatementTextLCU: this.workspace.receiptData.rcptStatementTextLCU || '',
          rcptStatementText: this.workspace.receiptData.rcptStatementText && this.workspace.receiptData.rcptStatementText.length > 0
            ? this.workspace.receiptData.rcptStatementText
            : defaultComment,
          rcptStatementReason: this.workspace.receiptData.rcptStatementReason && this.workspace.receiptData.rcptStatementReason.length > 0
            ? this.workspace.receiptData.rcptStatementReason
            : this.details.taskDetails.vorgBeschreibung,
        };
        this.statementClone = this.appSrv.helperObj.clone(this.statement);
      }
    }


  }

  switchEditMode(canSwitch?: boolean): void {
    if (canSwitch) {
      this.statementEditMode = !this.statementEditMode;
    }
  }
}
